import React from "react";
import style from "../woundAssessment.module.scss";
import warning from "../../../../static/images/icon-check-danger.png";
import { Confirmation } from "../../../secondary";
import { Button } from "../../../primary";

export const NewWoundConfirmDialog = ({ onClose, onConfirm }) => (
  <Confirmation onClose={onClose} title={" "}>
    <div className="text-center pr-5 pl-5">
      <p>
        <img src={warning} alt="warnning-icon" />
      </p>
      <p className="pb-3">Do you want to change this assessment to a new wound?</p>
      <div className="mb-2">
        <Button id="closeId" value="No" classes={{ className: `btn mr-4 pb-2 pt-2 ${style.no_btn}` }} onClick={onClose} />
        <Button value="Yes" classes={{ className: `btn mr-2 pb-2 pt-2 ml-2 ${style.yes_btn}` }} onClick={onConfirm} />
      </div>
    </div>
  </Confirmation>
);
